<ul *ngIf="listToDisplay?.length > 0">
  <li *ngFor="let option of listToDisplay, index as i"
      (click)="listItemSelected(i)"
      class="rounded-0 d-flex flex-column justify-content-center">
    <span>{{ option?.dropdownLabel }}</span>

    @if (option?.dropdownAdditionalDetails) {
      <span class="small-text">{{ option?.dropdownAdditionalDetails }}</span>
    }
  </li>
</ul>

